import { Component, Vue } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
import TableHead from '@/components/checking-accounts/TableHead/index.vue'
import TableBody from '@/components/checking-accounts/TableBody/index.vue'

import fetch from '@/helpers/fetch'

import vSelect from 'vue-select'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faFilter,
	faCaretUp,
	faChevronRight,
	faChevronLeft,
	faFileExcel,
	faCircleInfo,
} from '@fortawesome/free-solid-svg-icons'

Vue.component('v-select', vSelect)

library.add(
	faFilter,
	faCaretUp,
	faChevronRight,
	faChevronLeft,
	faFileExcel,
	faCircleInfo,
)

@Component({
	components: {
		Loader,
		TableHead,
		TableBody,
	},
})
export default class CheckingAccounts extends Vue {
	trials: any = null
	async mounted() {
		this.request({}, 1)
	}

	totalCount = 0
	totalPagesArray: any[] = []
	itemsPerPage = 50
	totalPages = 0
	viewPage = 1
	async request(filters, page?) {
		this.viewPage = page || 1
		this.trials = getLoadingTrials()
		const data = await this.getTrials(
			filters,
			page * this.itemsPerPage - this.itemsPerPage,
		)
		this.trials = data.trials

		this.totalCount = data.totalCount
		this.totalPages = Math.ceil(this.totalCount / this.itemsPerPage)
		this.totalPagesArray = new Array(this.totalPages)
	}

	async changePage(page) {
		this.viewPage = page
		this.$bvModal.hide('modal-pages')
		const tableHeadComponent: any = this.$refs.tableHeadComponent
		const filters = tableHeadComponent.getFilters()
		await this.request(filters, this.viewPage)
	}

	next() {
		if (this.viewPage < this.totalPages) {
			this.viewPage++
			this.changePage(this.viewPage)
		}
	}

	previous() {
		if (this.viewPage > 1) {
			this.viewPage--
			this.changePage(this.viewPage)
		}
	}

	// async getTrials(filters?, offset?) {
	// 	const response = await fetch.post('/api/checking-accounts/', {
	// 		filters,
	// 		offset,
	// 	})

	// 	return response.data
	// }

	async getTrials(filters?, offset?) {
		const response = await fetch.post('/api/checking-accounts/', {
			filters,
			offset,
		})

		const filteredData = response.data.trials.filter((trial) => {
			trial.subjects = trial.subjects.filter(
				(s) => s?.subject?.name !== '[EM BRANCO]',
			)

			return trial.subjects.length > 0
		})

		return {
			trials: filteredData,
			totalCount: response.data.totalCount || 0,
		}
	}

	downloading = false
	csvHref = ''
	downloadProp = 'contas-correntes.csv'
	async downloadCsv() {
		this.downloading = true

		const res = await fetch.get('/api/checking-accounts')
		const csvContent = res.data

		const encodedUri = encodeURI(csvContent)

		this.csvHref = 'data:text/csv;charset=utf-8,\uFEFF' + encodedUri

		const time = new Date().getTime() - 3 * 60 * 60 * 1000

		this.downloadProp =
			'contas-correntes-' +
			new Date(time).toISOString().substring(0, 16) +
			'.csv'

		await Vue.nextTick()
		const link: any = this.$refs.csvLink

		if (link && link.click) {
			link.click()
			this.downloading = false
		}
	}

	updateMap: any = makeUpdateMap()
	fieldHumanNames = {
		preDistributionCredit: 'Crédito pré distribuição',
		feePercentage: 'Porcentagem de honorários',
		feeAmount: 'Valor de honorários',
		decisionDate: 'Data de decisão',
		calculationMonths: 'Meses de cálculo',
		extraMonths: 'Meses extras',
		postFavorableDecisionMonths: 'Meses pós decisão favorável',
		postDistributionMonthlyCredit: 'Crédito pós distribuição mensal',
		postDecisionAmount: 'Valor pós decisão',
		postDistributionTotalCredit: 'Crédito pós distribuição total',
		totalBalance: 'Saldo total',
	}
}

function getLoadingTrials() {
	return [
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
	]
}

function makeUpdateMap() {
	const updateMap = {}
	const allFields = [
		{ mainFieldName: 'preDistributionCredit' },
		{ mainFieldName: 'feePercentage' },
		{ mainFieldName: 'feeAmount' },
		{ mainFieldName: 'decisionDate' },
		{ mainFieldName: 'calculationMonths' },
		{ mainFieldName: 'extraMonths' },
		{ mainFieldName: 'postFavorableDecisionMonths' },
		{ mainFieldName: 'postDistributionMonthlyCredit' },
		{ mainFieldName: 'postDecisionAmount' },
		{ mainFieldName: 'postDistributionTotalCredit' },
		{ mainFieldName: 'totalBalance' },
	]

	allFields.forEach((item) => {
		updateMap[item.mainFieldName] = {
			modifies: getUpdateList(item.mainFieldName).filter(
				(i) => i !== item.mainFieldName,
			),
		}
	})

	return updateMap
}

function getUpdateList(mainFieldName) {
	const newTree = { ...makeTree() }
	const knot = newTree[mainFieldName]
	traverseKnots(knot, newTree)
	const traversedOnlyTree = traversedOnly(newTree)
	const updateList = Object.keys(traversedOnlyTree)
	return updateList
}

function traverseKnots(knot, tree) {
	if (knot && !knot.traversed) {
		knot.traversed = true

		const modifies = knot.modifies

		if (modifies && modifies.length) {
			modifies.forEach((knot) => {
				traverseKnots(knot, tree)
			})
		}
	}
}

function traversedOnly(tree) {
	const traversedOnlyTree = {}
	const keys = Object.keys(tree)
	keys.forEach((key) => {
		if (tree[key].traversed) {
			traversedOnlyTree[key] = tree[key]
		}
	})

	return traversedOnlyTree
}

function makeTree() {
	const tree: any = {
		preDistributionCredit: {
			name: 'preDistributionCredit',
			modifies: null,
			traversed: false,
		},
		feePercentage: {
			name: 'feePercentage',
			modifies: null,
			traversed: false,
		},
		feeAmount: { name: 'feeAmount', modifies: null, traversed: false },
		decisionDate: {
			name: 'decisionDate',
			modifies: null,
			traversed: false,
		},
		calculationMonths: {
			name: 'calculationMonths',
			modifies: null,
			traversed: false,
		},
		extraMonths: { name: 'extraMonths', modifies: null, traversed: false },
		postFavorableDecisionMonths: {
			name: 'postFavorableDecisionMonths',
			modifies: null,
			traversed: false,
		},
		postDistributionMonthlyCredit: {
			name: 'postDistributionMonthlyCredit',
			modifies: null,
			traversed: false,
		},
		postDecisionAmount: {
			name: 'postDecisionAmount',
			modifies: null,
			traversed: false,
		},
		postDistributionTotalCredit: {
			name: 'postDistributionTotalCredit',
			modifies: null,
			traversed: false,
		},
		totalBalance: {
			name: 'totalBalance',
			modifies: null,
			traversed: false,
		},
	}

	tree.preDistributionCredit.modifies = [
		tree.feeAmount,
		tree.postDistributionMonthlyCredit,
		tree.postDistributionTotalCredit,
	]
	tree.feePercentage.modifies = [tree.feeAmount]
	tree.decisionDate.modifies = [
		tree.extraMonths,
		tree.postFavorableDecisionMonths,
	]
	tree.calculationMonths.modifies = [tree.postDistributionMonthlyCredit]
	tree.extraMonths.modifies = [tree.postDecisionAmount]
	tree.postFavorableDecisionMonths.modifies = [tree.totalBalance]
	tree.postDistributionMonthlyCredit.modifies = [
		tree.postDecisionAmount,
		tree.totalBalance,
	]
	tree.postDecisionAmount.modifies = [tree.postDistributionTotalCredit]

	return tree
}
